import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd">
      <rect className="fill-change" width="18" height="3" x="15" y="35" fill="#9F9F9F" rx="1.5" />
      <path
        className="stroke-change"
        stroke="#9F9F9F"
        strokeWidth="3"
        d="M8.5 11.5v19h31v-19h-31z"
      />
    </g>
  </svg>
);
